import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '@/features/client/settings';
import { clientGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/client/settings')({
  beforeLoad: clientGuard,
  component: ClientSettingsRoute,
});

function ClientSettingsRoute() {
  return <SettingsPage />;
}
